import request from '@/config/axios'
import type { RegisterVO, UserLoginVO } from './types'

export interface SmsCodeVO {
  mobile: string
  scene: number
}

export interface SmsLoginVO {
  mobile: string
  code: string
}

export interface VerifyMfaVO {
  mfaToken:string
  code:string
}

// 登录
export const login = (data: UserLoginVO) => {
  return request.post({
    url: '/txn/auth/user/login',
    data,
    headers: {
      isEncrypt: false
    }
  })
}

// 注册
export const verifyMfa = (data: VerifyMfaVO) => {
  return request.post({ url: 'txn/auth/user/verifyMfa', data })
}
// 注册
export const register = (data: RegisterVO) => {
  return request.post({ url: '/txn/auth/user/register', data })
}

// 使用租户名，获得租户编号
export const getTenantIdByName = (name: string) => {
  return request.get({ url: '/system/tenant/get-id-by-name?name=' + name })
}

// 使用租户域名，获得租户信息
export const getTenantByWebsite = (website: string) => {
  return request.get({ url: '/system/tenant/get-by-website?website=' + website })
}

// 登出
export const loginOut = () => {
  return request.post({ url: '/txn/auth/user/logout' })
}

// 获取用户权限信息
export const getInfo = () => {
  return request.get({ url: '/txn/auth/user/get-permission-info' })
}

/**
 * 
 * @param data 获取登录验证码
 * @returns 
 * 注册 41 
 * 登录 42 
 * mfa登录二次验证 43 
 * 重置密码 44
 */
export const sendSmsCode = (data: SmsCodeVO) => {
  return request.post({ url: '/txn/auth/user/send-sms-code', data })
}

// 短信验证码登录
export const smsLogin = (data: SmsLoginVO) => {
  return request.post({ url: '/system/auth/sms-login', data })
}



// 获取验证图片以及 token
export const getCode = (data: any) => {
  return request.postOriginal({ url: 'system/captcha/get', data })
}

// 滑动或者点选验证
export const reqCheck = (data: any) => {
  return request.postOriginal({ url: 'system/captcha/check', data })
}

// 通过短信重置密码
export const smsResetPassword = (data: any) => {
  return request.post({ url: '/txn/auth/user/reset-password', data })
}
